import { Policy } from "../../schema/types/policy/entity";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export const policyHelpers = {
  getAllPrincipalLinks(policy: Policy) {
    const links: string[] = [];
    for (let binding of policy.bindings || []) {
      for (let link of binding.principalLinks) {
        if (!links.includes(link)) {
          links.push(link);
        }
      }
    }
    return links;
  },
};

export interface PolicyTableItem extends Policy {
  selfLink: string;
}

interface GetPolicyTableItemProps {
  link?: string;
  name?: string;
  item?: Policy;
}
export function getPolicyTableItem({ link, name, item }: GetPolicyTableItemProps): PolicyTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "policy",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      origin: "default",
      targetKind: "" as any,
      id: "",
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "policy",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    origin: "default",
    // TODO test if this breaks table column
    targetKind: "" as any,
    lastModified: "",
    tags: {},
    version: 1,
  };
}

export const STORAGE_KEY_POLICY_LIST_HIDE_BUILTIN = "STORAGE_KEY_POLICY_LIST_HIDE_BUILTIN";
